import { render, staticRenderFns } from "./LocationTariffsList.vue?vue&type=template&id=fb88eb5e&"
import script from "./LocationTariffsList.vue?vue&type=script&lang=js&"
export * from "./LocationTariffsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports